import { Component, forwardRef, inject, Input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TenantRoleService } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-tenant-role-select',
  templateUrl: './tenant-role-select.component.html',
  styleUrls: ['./tenant-role-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TenantRoleSelectComponent),
      multi: true,
    },
  ],
})
export class TenantRoleSelectComponent extends AbstractFormControl<string[]> {
  readonly tenantRoleService = inject(TenantRoleService);

  @Input()
  @Tracked()
  tenantId!: string;

  tenantRoles = asyncComputed(
    () => {
      if(!this.tenantId) {
        return [];
      }
      return this.tenantRoleService.getTenantRolesWithSmallerWeight(this.tenantId);
    },
  );
}
